import React from 'react';
import { openProfilePage } from 'react/profile/card/cardActions';

// Holds the loaded card's shape while player/profile is in flight, so the popup doesn't jump.
export default function CardSkeleton({ player }) {
	return (
		<div className='profile-card profile-card--loading'>
			<div className='profile-card__banner'>
				<div className='profile-card__name-row'>
					<span className='profile-card__dot' />
					<span className='profile-card__name'>
						{player &&
						<a
							className='profile-card__name-link'
							href={player.getProfileUrl()}
							onClick={(event) => {
								event.preventDefault();
								event.stopPropagation();
								openProfilePage(player);
							}}
						>
							{player.username}
						</a>
						}
					</span>
				</div>
				<span className='profile-card__skeleton' style={{ width: 200, height: 12, marginTop: 8 }} />
			</div>
			<div className='profile-card__games'>
				{[0, 1, 2].map((row) => (
					<div key={row} className='profile-card__game-row'>
						<span className='profile-card__skeleton' style={{ width: 36, height: 36 }} />
						<span className='profile-card__skeleton' style={{ height: 14, width: '70%' }} />
					</div>
				))}
			</div>
			<div className='profile-card__with'><span className='profile-card__skeleton' style={{ height: 12, width: '60%' }} /></div>
			<div className='profile-card__footer'>
				<span className='profile-card__skeleton' style={{ flex: 1, height: 34 }} />
				<span className='profile-card__skeleton' style={{ flex: 1, height: 34 }} />
				<span className='profile-card__skeleton' style={{ width: 34, height: 34 }} />
			</div>
		</div>
	);
}
